import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const Container = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-direction: ${({ legendPlacement }) => (legendPlacement === 'right' ? 'row' : 'column')};
	gap: 1rem;

	padding-bottom: 2rem;

	@media ${Breakpoints.mobile} {
		flex-direction: column;
	}
`;

export const ChartContainer = styled.div`
	margin: auto;
	width: ${(props) => props.width};
`;
